<template>
  <!-- width="600px" 或者  width="60%"   -->
  <div>
    <el-dialog
      :close-on-click-modal="false"
      title="查看部门"
      :show-close="true"
      :visible="true"
      :before-close="handleBeforeClose"
      width="700px"
    >
      <div class="dialog__container">
        <el-table
          v-loading="tableLoading"
          :data="treeList"
          max-height="400"
          border
          ref="multipleTable"
          row-key="id"
          style="width: 100%"
          :tree-props="{children: 'childrenList' }"
        >
          >
          <!-- <el-table-column show-overflow-tooltip prop="targetDate" label="月份" width="120"></el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            prop="departmentName"
            fixed
            width="260"
            label="部门名称"
          ></el-table-column>
          <el-table-column prop="employeeNum" label="成员数" fixed width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="partTimeNum" label="兼任人员" fixed show-overflow-tooltip></el-table-column>
          <!-- <el-table-column label=" "></el-table-column> -->
          <el-table-column label="操作" width="98px" fixed="right">
            <template slot-scope="scope">
              <!-- <el-button size="mini" type="text" @click="adjustPeople(scope.row)">调整</el-button> -->
              <!-- <div class="btn-divide"></div> -->
              <el-button size="mini" type="text" @click="editDepartment(scope.row)">编辑</el-button>
              <div class="btn-divide"></div>
              <el-button type="text" size="mini" @click="deleteDepartment(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
        <el-button class="plr28" type="primary" size="mini" @click="handleConfirm">确定</el-button>
      </span>
    </el-dialog>
    <edit-department :unitId="editData.id" :editData="detail" v-if="showEditDepartment" @confirm="editDepartmentConfirm" @cancel="showEditDepartment=false"></edit-department>
  </div>
</template>

<script>
import { getDepartmentTree, deleteDepartment } from "@/api/UnitManagement";
import EditDepartment from "./EditDepartment";
export default {
  data() {
    return {
      form: {
        contactsPhone: "",
        contactsName: "",
        creditCode: "",
        unitName: "",
      },
      treeList: [],
      tableLoading: false,
      showEditDepartment: false,
      detail: {},
    };
  },
  components: {
    EditDepartment,
  },
  props: {
    editData: {
      type: Object,
      required: true,
    },
  },
  created() {
    console.log(this.editData);
    this.getDepartmentTree();
  },
  methods: {
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    async load(tree, treeNode, resolve) {
      console.log(tree);
    },
    async getDepartmentTree() {
      this.tableLoading = true;
      const res = await getDepartmentTree({ unitId: this.editData.id });
      if (res.code === 200) {
        this.treeList = res.data;
        setTimeout(() => {
          this.$refs["multipleTable"].doLayout();
        }, 500);
      }
      this.tableLoading = false;
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      this.$emit("cancel");
    },
    editDepartment(row) {
      this.detail = row;
      this.showEditDepartment = true;
    },
    deleteDepartment(row) {
      const idList = [ row.id ]
      this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await deleteDepartment({idList})
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getDepartmentTree()
          }
        }).catch((err) => {
          console.log(err)
        })
    },
    editDepartmentConfirm() {
      this.showEditDepartment = false
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/useUnits/components/CheckDepartment.vue